import { ELEMENT_TYPE } from '../../../../constants/types';
import EditAccordionBlock, { displayName as accordionDisplayName } from '../EditAccordionBlock';
import EditFormBlock, { displayName as formDisplayName } from '../EditFormBlock';
import EditImageBlock, { displayName as imageDisplayName } from '../EditImageBlock';
import EditJsonBlock, { displayName as jsonDisplayName } from '../EditJsonBlock';
import EditQuestionAnswerBlock, {
  displayName as questionAnswerDisplayName,
} from '../EditQuestionAnswerBlock';
import EditTextBlock, { displayName as textDisplayName } from '../EditTextBlock';
import EditVideoBlock, { displayName as videoDisplayName } from '../EditVideoBlock';

export const ELEMENT_TYPE_EDIT_COMPONENT = {
  [ELEMENT_TYPE.FormBlock]: EditFormBlock, // legacy
  [ELEMENT_TYPE.CustomFormBlock]: EditFormBlock,
  [ELEMENT_TYPE.ImageBlock]: EditImageBlock,
  [ELEMENT_TYPE.TextBlock]: EditTextBlock,
  [ELEMENT_TYPE.JsonBlock]: EditJsonBlock,
  [ELEMENT_TYPE.AccordionBlock]: EditAccordionBlock,
  [ELEMENT_TYPE.VideoBlock]: EditVideoBlock,
  [ELEMENT_TYPE.QuestionAnswerBlock]: EditQuestionAnswerBlock,
};

export const ELEMENT_TYPE_DISPLAY_NAME = {
  [ELEMENT_TYPE.FormBlock]: formDisplayName, // legacy
  [ELEMENT_TYPE.CustomFormBlock]: formDisplayName,
  [ELEMENT_TYPE.ImageBlock]: imageDisplayName,
  [ELEMENT_TYPE.TextBlock]: textDisplayName,
  [ELEMENT_TYPE.JsonBlock]: jsonDisplayName,
  [ELEMENT_TYPE.AccordionBlock]: accordionDisplayName,
  [ELEMENT_TYPE.VideoBlock]: videoDisplayName,
  [ELEMENT_TYPE.QuestionAnswerBlock]: questionAnswerDisplayName,
};

export const ELEMENT_TYPE_DISPLAY_ORDER = [
  ELEMENT_TYPE.TextBlock,
  ELEMENT_TYPE.ImageBlock,
  ELEMENT_TYPE.VideoBlock,
  ELEMENT_TYPE.CustomFormBlock,
  ELEMENT_TYPE.JsonBlock,
  ELEMENT_TYPE.AccordionBlock,
  ELEMENT_TYPE.QuestionAnswerBlock,
];

export const ELEMENT_COMPONENT_NOT_FOUND_MESSAGE =
  'There is no registered component available for this type.';
